import { render } from "./VInputStepper.vue?vue&type=template&id=38bc3527"
import script from "./VInputStepper.vue?vue&type=script&lang=js"
export * from "./VInputStepper.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/bookdialysis/bookdialysis/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__